"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnableNotificationWatcher = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var actionButtonStyles_1 = require("../../../styles/button/actionButtonStyles");
var getFirebaseMessagingToken_1 = require("../../../utilities/get/getFirebaseMessagingToken");
var ErrorMessage_1 = require("../../../com/message/ErrorMessage/ErrorMessage");
var SpinnerWidget_1 = require("../../../com/widget/SpinnerWidget/SpinnerWidget");
var emotion_1 = require("emotion");
var appStylesBase_1 = require("../../../styles/appStylesBase");
var isIos_1 = require("../../../utilities/is/isIos");
var messaging_1 = require("firebase/messaging");
var appStyleClasses_1 = require("../../../styles/appStyleClasses");
var react_redux_1 = require("react-redux");
var getIsExistingTokenFromState_1 = require("../../../state/getters/getIsExistingTokenFromState");
var react_redux_2 = require("react-redux");
var createErrorAction_1 = require("../../../actionCreators/createErrorAction");
var getDontAskForNotification_1 = require("../../../state/getters/getDontAskForNotification");
var useUpdatePushTokens_1 = require("../../../hooks/useUpdatePushTokens");
var analyticsEventBase_1 = require("../../../sdks/firebase/analyticsEventBase");
var descriptionHelper_1 = require("../../../utilities/descriptionHelper");
var clientMeta_1 = require("../../../utilities/clientMeta");
var HEIGHT = 95;
var TRANSITION_SECONDS = 0.25;
var description = 'EnableNotificationWatcher';
var EnableNotificationWatcher = function (_a) {
    var _b = _a.styles, styles = _b === void 0 ? '' : _b, _c = _a.message, message = _c === void 0 ? 'Turn on notifications for messages and alerts?' : _c;
    var _d = (0, react_1.useState)(false), showPrompt = _d[0], setShowPrompt = _d[1];
    var notificationPermission = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return (_a = state.windowMeta) === null || _a === void 0 ? void 0 : _a.notificationPermission;
    });
    var canAskForNotification = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return (_a = state.windowMeta) === null || _a === void 0 ? void 0 : _a.canAskForNotification;
    });
    var isLoadingUser = (0, react_redux_1.useSelector)(function (state) {
        return !state.currentUnscopeUser;
    });
    var dontAskToEnableNotifications = (0, react_redux_1.useSelector)(function (state) {
        return (0, getDontAskForNotification_1.getDontAskForNotification)({ state: state });
    });
    var isExistingToken = (0, react_redux_1.useSelector)(function (state) {
        return (0, getIsExistingTokenFromState_1.getIsExistingTokenFromState)({ state: state });
    });
    var signingOut = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return (_a = state.currentUser) === null || _a === void 0 ? void 0 : _a.signingOut;
    });
    var dispatch = (0, react_redux_2.useDispatch)();
    var needToken = !isExistingToken &&
        !isLoadingUser &&
        !dontAskToEnableNotifications &&
        !signingOut;
    var _e = (0, react_1.useState)(false), showSpinner = _e[0], setShowSpinner = _e[1];
    var _f = (0, react_1.useState)(false), noSupport = _f[0], setShowNoSupport = _f[1];
    var submit = (0, useUpdatePushTokens_1.useUpdatePushTokens)({ parentDescription: description }).submit;
    var _g = (0, react_1.useState)(false), browserMessagingSupport = _g[0], setBrowserMessagingSupport = _g[1];
    var _h = (0, react_1.useState)(null), ref = _h[0], setRef = _h[1];
    var ios = (0, isIos_1.isIos)();
    var isNative = clientMeta_1.clientMeta.platform === 'AndroidNative' ||
        clientMeta_1.clientMeta.platform === 'IosNative';
    (0, react_1.useEffect)(function () {
        if (isNative && needToken && window.setMessagingToken) {
            window.setMessagingToken();
        }
    }, [isNative, needToken]);
    (0, react_1.useEffect)(function () {
        var getIsSupported = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
            var support;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, messaging_1.isSupported)()];
                    case 1:
                        support = _a.sent();
                        setBrowserMessagingSupport(support);
                        return [2 /*return*/];
                }
            });
        }); };
        getIsSupported();
    }, []);
    var saveToken = function (token) { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch({
                        type: 'SET_WINDOW_META',
                        values: { firebaseMessagingToken: token },
                        description: description,
                    });
                    return [4 /*yield*/, submit({
                            token: token,
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (needToken) {
            var getToken = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                return tslib_1.__generator(this, function (_a) {
                    if (typeof Notification !== 'undefined' &&
                        Notification.permission !== 'granted') {
                        // granted is handled be UpdateMessagingTokenWatcher.tsx
                        setShowPrompt(true);
                    }
                    return [2 /*return*/];
                });
            }); };
            getToken();
        }
        return;
    }, [needToken, ref, saveToken]);
    (0, react_1.useEffect)(function () {
        if (showPrompt && ref) {
            var timeOut_1 = setTimeout(function () {
                if (ref) {
                    ref.style.top = "0px";
                }
            }, 100); // we need some type of time out
            var timeOut2_1 = setTimeout(function () {
                if (ref) {
                    ref.style.height = 'initial';
                }
            }, TRANSITION_SECONDS * 1000);
            return function () {
                clearTimeout(timeOut_1);
                clearTimeout(timeOut2_1);
            };
        }
        return;
    }, [showPrompt, ref]);
    if (browserMessagingSupport &&
        needToken &&
        showPrompt &&
        canAskForNotification &&
        !ios) {
        return (react_1.default.createElement("div", { ref: setRef, className: "".concat((0, descriptionHelper_1.descriptionHelper)(description), " ").concat((0, emotion_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n          position: fixed;\n          top: ", "px;\n          transition: all ", "s ease-in;\n          background-color: ", ";\n          width: 100%;\n          text-align: center;\n          height: ", "px;\n          padding: ", ";\n          color: ", ";\n          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n          z-index: ", ";\n          ", "\n        "], ["\n          position: fixed;\n          top: ", "px;\n          transition: all ", "s ease-in;\n          background-color: ", ";\n          width: 100%;\n          text-align: center;\n          height: ", "px;\n          padding: ", ";\n          color: ", ";\n          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n          z-index: ", ";\n          ", "\n        "])), -HEIGHT, TRANSITION_SECONDS, (0, appStylesBase_1.appStylesBase)().backgroundColor.neutral.darkest, HEIGHT, (0, appStylesBase_1.appStylesBase)().spacing.small, (0, appStylesBase_1.appStylesBase)().textColor.primary.lightest, (0, appStylesBase_1.appStylesBase)().zIndex.levelFour, styles), " ") },
            react_1.default.createElement("p", null, message),
            showSpinner && (react_1.default.createElement(SpinnerWidget_1.SpinnerWidget, { className: (0, emotion_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n              margin: ", ";\n            "], ["\n              margin: ", ";\n            "])), (0, appStylesBase_1.appStylesBase)().spacing.small) })),
            !showSpinner && (react_1.default.createElement("div", null,
                react_1.default.createElement("button", { type: "button", className: "".concat((0, actionButtonStyles_1.actionButtonStyles)(), " ").concat((0, emotion_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n                margin: ", ";\n              "], ["\n                margin: ", ";\n              "])), (0, appStylesBase_1.appStylesBase)().spacing.small)), onClick: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                        var token, error_1;
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    setShowSpinner(true);
                                    (0, analyticsEventBase_1.analyticsEventBase)({
                                        event: 'Enable push notification',
                                    });
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 6, , 7]);
                                    return [4 /*yield*/, (0, getFirebaseMessagingToken_1.getFirebaseMessagingToken)({
                                            askForPermission: true,
                                        })];
                                case 2:
                                    token = _a.sent();
                                    if (!token) return [3 /*break*/, 4];
                                    return [4 /*yield*/, saveToken(token)];
                                case 3:
                                    _a.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    setShowNoSupport(true);
                                    _a.label = 5;
                                case 5: return [3 /*break*/, 7];
                                case 6:
                                    error_1 = _a.sent();
                                    dispatch((0, createErrorAction_1.createErrorAction)({
                                        description: description,
                                        error: error_1,
                                    }));
                                    return [3 /*break*/, 7];
                                case 7:
                                    setShowSpinner(false);
                                    return [2 /*return*/];
                            }
                        });
                    }); } }, "Yes"),
                ' ',
                react_1.default.createElement("button", { type: "button", className: (0, emotion_1.css)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n                ", ";\n              "], ["\n                ", ";\n              "])), appStyleClasses_1.appStyleClasses.hollowButtonStyles()), onClick: function () {
                        (0, analyticsEventBase_1.analyticsEventBase)({
                            event: 'Denied push notification',
                        });
                        dispatch({
                            type: 'SET_COOKIE_STORAGE',
                            description: description,
                            values: {
                                dontAskToEnableNotificationMs: Date.now(),
                            },
                        });
                    } }, "No"))),
            notificationPermission === 'denied' && (react_1.default.createElement(ErrorMessage_1.ErrorMessage, { className: (0, emotion_1.css)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n              margin-top: ", ";\n            "], ["\n              margin-top: ", ";\n            "])), (0, appStylesBase_1.appStylesBase)().spacing.small) }, "Your browser is blocking notifications.")),
            noSupport && (react_1.default.createElement(ErrorMessage_1.ErrorMessage, { className: (0, emotion_1.css)(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n              margin-top: ", ";\n            "], ["\n              margin-top: ", ";\n            "])), (0, appStylesBase_1.appStylesBase)().spacing.small) }, "Your browser does not support push notifications. It may be related to your privacy settings."))));
    }
    return null;
};
exports.EnableNotificationWatcher = EnableNotificationWatcher;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
